<template>
  <div class="hello">
    <div class="editMyTop">
      <ShowNavHead />
    </div>
    <div class="MyBox" v-loading="loading">
      <div class="entInfoContainer" style="margin-top:16px">
        <div class="account-box">
          <el-form :model="ruleForm" label-position="top" status-icon :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="用户姓名" prop="userName">
              <el-input v-model="ruleForm.userInfo.userName" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="userTel">
              <el-input v-model="ruleForm.userInfo.userTel" disabled></el-input>
            </el-form-item>
            <el-form-item label="工号">
              <el-input v-model="ruleForm.userInfo.userNumber" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="登录邮箱" prop="userEmail">
              <el-input v-model="ruleForm.userInfo.userEmail" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="账号密码" prop="userInfo.userPwd">
              <el-input type="password" v-model="ruleForm.userInfo.userPwd" show-password placeholder="密码中必须包含大写字母或者小写字母、数字、特殊字符，并且长度在6位以上" suffix-icon="">
              </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm.checkPass" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" class="addBtn" @click="submitForm('ruleForm')" :disabled="isEdit">确认修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "../../common"; //输入框
// import IdentifyInput from "../../components/form/textInput";
export default {
  data: function () {
    var validatePass = (rule, value, callback) => {
      if(value && value.length>0){
        // let regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{6,30}');
        let regex = /^(?=.*[a-zA-Z])(?=.*[1-9])(?=.*[\W]).{6,}$/;
        if(!regex.test(value)){
          callback(new Error('您的密码复杂度太低（密码中必须包含大写字母或者小写字母、数字、特殊字符，并且长度在6位以上）'));
        }else{
          callback();
        }
      }else{
        callback(new Error(''));
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.userInfo.userPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        userInfo: {
          newuserid: '',
          userTel: '',
          userName: '',
          userEmail: '',
          userNumber: '',
          stridcard: '',
          strJobfunclabel1: '',
          strJobfunclabel2: '',
          strTimepro1: '',
          strTimepro2: '',
          strtopuserid1: '',
          strtopuserid2: '',
          strWorkJob1: '',
          strWorkJob2: '',
          strWorkState: '否',
          StrIspartner: '否',
          dtEntryDate: '',
          dtQuitDate: '',
          strPuserid: '',
          operation: '',
          userPwd: '',
        },
        inst: [{
          strorgancode: '',
          strorganname: '',
          rolename: '',
          roletype: ''
        }],
        checkPass: ''
      },
      rules: {
        'userInfo.userName': [
          { required: true, message: '请输入用户姓名', trigger: 'blur' }
        ],
        'userInfo.userTel': [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        'userInfo.userPwd': [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, required: true, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, required: true, trigger: 'blur' }
        ]
      },
      submitID: '',
      isEdit: false
    };
  },
  created() {
    this.submitID = Cookies.get("userid-b")
    this.getDetailMember()
  },
  methods: {
    //账号详情
    // getDetailMember() {
    // xz.getUserDetail(this.submitID).then(res => {
    //   if (res.status == 'ok') {
    //     if (res.msg.Roletype == 'adminuser') {
    //       this.isEdit = true
    //     } else {
    //       this.isEdit = false
    //     }
    //     this.ruleForm = {
    //       userTel: res.msg.Strmobile,
    //       userName: res.msg.Username,
    //       userEmail: res.msg.StrEmail,
    //       instcode: res.msg.Strinstcode,
    //       roletype: res.msg.Roletype,
    //       instname: res.msg.Strinstname,
    //       entid: res.msg.Strtopuserid,
    //       nations: '',
    //       userPwd: '88088'
    //     }
    //   }
    // });
    // },
    getDetailMember() {
      this.loading = true;
      let dtlQuery = {
          mainuserid:'',
          useridr: this.submitID
        }
      xz.getauthJbUserDetail(dtlQuery).then(res => {
        if (res) {
          let userinfo = res.msg;
          this.loading = false;
          this.ruleForm.userInfo = {
            newuserid: userinfo.Userid,
            userTel: userinfo.Strmobile,
            userName: userinfo.Username,
            userEmail: userinfo.StrEmail,
            userNumber: userinfo.UserNumber,
            stridcard: userinfo.Stridcard,
            strJobfunclabel1: userinfo.StrJobfunclabel1,
            strJobfunclabel2: userinfo.StrJobfunclabel2,
            strTimepro1: userinfo.StrTimepro1,
            strTimepro2: userinfo.StrTimepro2,
            strtopuserid1: userinfo.Strtopuserid1,
            strtopuserid2: userinfo.Strtopuserid2,
            strWorkJob1: userinfo.StrWorkJob1,
            strWorkJob2: userinfo.StrWorkJob2,
            strWorkState: userinfo.StrWorkState,
            StrIspartner: userinfo.StrIspartner,
            dtEntryDate: userinfo.DtEntryDate == '1900-01-01T00:00:00' ? '' : userinfo.DtEntryDate,
            dtQuitDate: userinfo.DtQuitDate == '1900-01-01T00:00:00' ? '' : userinfo.DtQuitDate,
            strPuserid: userinfo.StrPuserid,
            userPwd: ''
          };
          this.ruleForm.checkPass = '';
          this.ruleForm.inst = null;
        } else {
          this.$message.error('系统出错');
        }
      })
    },
    //确定修改
    submitForm(formName) {
      // console.log('dd',this.submitID,this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // xz.saveLowUserInfo(this.submitID, this.ruleForm.entid, this.ruleForm).then(res => {
          //   if (res.status == 'ok') {
          //     this.$message({ type: 'success', message: '修改成功' })
          //     this.$store.commit("setLogin", false);
          //     this.$router.push({ path: '/login' })
          //   }
          // });
          this.ruleForm.userInfo.dtEntryDate ? '' : this.ruleForm.userInfo.dtEntryDate = '1900-01-01T00:00:00';
          this.ruleForm.userInfo.dtQuitDate ? '' : this.ruleForm.userInfo.dtQuitDate = '1900-01-01T00:00:00';
          this.ruleForm.operation = 'pwd';
          xz.editPsw('saveJbUserInfo', this.ruleForm).then(res => {
            if (res.status == 'ok') {
              window.localStorage.setItem('needEdit', 'false')
              this.$message.success('修改成功');
              Cookies.remove("userid-b");
              Cookies.remove("entid-b");
              Cookies.remove("token");
              this.$store.commit("setLogin", false);
              localStorage.removeItem('router');
              localStorage.removeItem('activeRouter');
              localStorage.removeItem('isPartner');
              location.href = "/";
            } else {
              this.$message.error('修改失败');
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.account-box {
  width: 550px;
}
</style>
<style>
.account-box .el-form-item__content {
  width: 550px;
}
.account-box .addBtn {
  margin-left: 0;
  background: #19bd92;
}
.account-box .el-form-item__label {
  line-height: inherit;
}
.account-box i.el-icon-circle-close {
  display: none;
}
.account-box .el-form-item__error{
  color: #909399;
}
.account-box i.el-icon-circle-check{
  display: none;
}
</style>